import { SAGA_ACTIONS } from "../../constants";
import { useApiCall } from "../common/appApiCallHook";



export function thirdPartyApi() {

    const callApi = useApiCall();

    const quickBookAuth = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.AUTH, data, onSuccess, onError);
    }
    const quickBookCallback = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.CALLBACK, data, onSuccess, onError);
    }
    const quickBookImportData = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.IMPORT_DATA, data, onSuccess, onError);
    }
    const fetchQuickBookAccountCharts = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.FETCH_ACCOUNT_CHARTS, data, onSuccess, onError);
    }
    const postQuickBookAccountCharts = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.POST_ACCOUNT_CHARTS, data, onSuccess, onError);
    }
    const qbFetchOpenningAcc = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_OPENNING_BALANCE, data, onSuccess, onError);
    }
    const postQuickBookBeginningBalance = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_POST_OPENNING_BALANCE, data, onSuccess, onError);
    }
    const qbFetchBSPL = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_BS_PL, data, onSuccess, onError);
    }
    const qbPostBSPL = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_POST_BS_PL, data, onSuccess, onError);
    }
    const qbFetchBS = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_BS, data, onSuccess, onError);
    }
    const qbFetchPL = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_PL, data, onSuccess, onError);
    }


    return {
        quickBookAuth,
        quickBookCallback,
        quickBookImportData,
        fetchQuickBookAccountCharts,
        postQuickBookAccountCharts,
        qbFetchOpenningAcc,
        postQuickBookBeginningBalance,
        qbFetchBSPL,
        qbPostBSPL,
        qbFetchBS,
        qbFetchPL
    }
}